import angular from 'angular'
import hasPermitDirective from './hasPermitDirective'

export default angular
    .module('app.hasPermit', [])
    .directive('hasPermit', hasPermitDirective)
    .name



// WEBPACK FOOTER //
// ./src/components/hasPermit/index.js